export default __webpack_public_path__ + "static/media/mac.e4b614a6.jpg";